import { ArrowLeft } from "@untitledui/icons/ArrowLeft";
import TopicCard from "../TopicCard";
import Breadcrumbs from "../Breadcrumbs";
import { useNavigate } from "react-router-dom";

const Product = ({ title, description, levelIcon, topicsList, pageColor = "purple", onTopicClick, showBreadcrumbs = false }) => {
  const navigation = useNavigate();

  const goBack = () => {
    navigation(-1);
  };
  return (
    <div className={`product-page ${pageColor || ""}`}>
      <div className="container">
        <div className="product-page__head flex flex-align-center flex-between mb-64">
          <div>
            <button className="back-button flex flex-align-center mb-24" onClick={goBack}>
              <ArrowLeft className="mr-8" size={20} />
              Back
            </button>
            <img src={levelIcon} alt={title} />
            <h3 className="mb-12">{title}</h3>
            <p className="text-color-grey">{description}</p>
          </div>
          <img src={levelIcon} alt={title} />
        </div>
        <div className="product-page__content">
          {showBreadcrumbs && (
            <div className="product-page__breadcrumbs">
              <Breadcrumbs />
            </div>
          )}
          <h6 className="mb-24">Pick a topic to get started</h6>
          {topicsList?.length > 0 ? (
            <ul className="topic-list flex flex-wrap">
              {topicsList.map(item => (
                <TopicCard key={item.id} id={item.id} title={item.name} description={item.description} imageUrl={item.image_url} questionScreen={topicId => onTopicClick(topicId, item)} />
              ))}
            </ul>
          ) : (
            <p className="text-color-grey text-center">No topics available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Product;
